import React from 'react';
import LinkBuilderCard from './LinkBuilderCard';
import {
  LineChart, Line, BarChart, Bar, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const COLORS = ['#dc2626', '#991b1b', '#7f1d1d', '#450a0a'];
const TOOLTIP_STYLE = { backgroundColor: '#1a1a1a', border: '1px solid #dc2626' };

const ChartCard = ({ title, children }) => (
  <div className="bg-zinc-900/80 backdrop-blur-xl border border-red-900/30 rounded-lg p-6">
    <h3 className="text-xl font-black text-white mb-4">{title}</h3>
    <ResponsiveContainer width="100%" height={300}>
      {children}
    </ResponsiveContainer>
  </div>
);

const AnalyticsTab = ({ analytics, token }) => {
  if (!analytics) return null;

  return (
    <div className="space-y-8" data-testid="analytics-tab">
      <LinkBuilderCard token={token} />
      <ChartCard title="Daily Page Views (Last 30 Days)">
        <LineChart data={analytics.charts.daily_views}>
          <CartesianGrid strokeDasharray="3 3" stroke="#444" />
          <XAxis dataKey="date" stroke="#999" />
          <YAxis stroke="#999" />
          <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={{ color: '#fff' }} />
          <Legend />
          <Line type="monotone" dataKey="count" stroke="#dc2626" strokeWidth={2} name="Views" />
        </LineChart>
      </ChartCard>

      <ChartCard title="Device Types">
        <PieChart>
          <Pie
            data={analytics.charts.devices}
            dataKey="count"
            nameKey="device"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label
          >
            {analytics.charts.devices.map((entry, index) => (
              <Cell key={entry.device} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip contentStyle={TOOLTIP_STYLE} />
          <Legend />
        </PieChart>
      </ChartCard>

      <ChartCard title="Top 10 Countries">
        <BarChart data={analytics.charts.locations}>
          <CartesianGrid strokeDasharray="3 3" stroke="#444" />
          <XAxis dataKey="country" stroke="#999" />
          <YAxis stroke="#999" />
          <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={{ color: '#fff' }} />
          <Bar dataKey="count" fill="#dc2626" name="Visitors" />
        </BarChart>
      </ChartCard>

      <ChartCard title="PWA Installs (Last 30 Days)">
        <LineChart data={analytics.charts.daily_installs ?? analytics.charts.daily_downloads}>
          <CartesianGrid strokeDasharray="3 3" stroke="#444" />
          <XAxis dataKey="date" stroke="#999" />
          <YAxis stroke="#999" />
          <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={{ color: '#fff' }} />
          <Legend />
          <Line type="monotone" dataKey="total" stroke="#dc2626" strokeWidth={2} name="Total Installs" />
          <Line type="monotone" dataKey="unique" stroke="#22c55e" strokeWidth={2} name="Unique Installs" />
        </LineChart>
      </ChartCard>
    </div>
  );
};

export default AnalyticsTab;
